import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { getPoolId } from '../lib/global';

import { ScreenWrapper, Submit, TextHeaderMedium, ButtonsWrapper, Logo, ErrorContainer, Error } from '../styles';

const SearchParams = new URLSearchParams(window.location.search);

export default React.memo(() => {
    const history = useHistory();

    const [eventId] = React.useState(SearchParams.get('eventId'));
    const [feedbackToken] = React.useState(SearchParams.get('feedbackToken'));
    const [username] = React.useState(SearchParams.get('username'));
    const [cognitoError, setCognitoError] = React.useState(null);

    const resetError = React.useCallback(() => setCognitoError(null), [setCognitoError]);

    const setError = React.useCallback(
        error => {
            setCognitoError(error);

            setTimeout(resetError, 5000);
        },
        [setCognitoError, resetError]
    );

    const goToLogin = React.useCallback(() => {
        history.push('/');
    }, [history]);

    const goToForgottenPassword = React.useCallback(() => {
        history.push('/forgotten-password');
    }, [history]);

    const handleReject = React.useCallback(
        async event => {
            event.preventDefault();
            resetError();

            const params = {
                EventId: eventId,
                FeedbackToken: feedbackToken,
                FeedbackValue: 'Invalid',
                UserPoolId: getPoolId(),
                Username: username
            };

            try {
                const response = await fetch('/auth/update-auth-event-feedback', {
                    method: 'POST',
                    body: JSON.stringify(params)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                goToForgottenPassword();
            } catch (error) {
                console.log(error, error.stack);
                setError('Something went wrong, please try again.');
            }
        },
        [eventId, feedbackToken, username, setError, resetError, goToForgottenPassword]
    );

    return (
        <ScreenWrapper>
            <Logo />
            {cognitoError && (
                <ErrorContainer>
                    <Error onClick={resetError}>{cognitoError}</Error>
                </ErrorContainer>
            )}
            <div>
                <TextHeaderMedium hasBigPaddingBottom>
                    <span>You have told us that this login attempt was not from you.</span>
                </TextHeaderMedium>
                <TextHeaderMedium>
                    <span>To prevent unauthourised access to your account, reset your password.</span>
                </TextHeaderMedium>
                <ButtonsWrapper>
                    <Submit onClick={handleReject} type="button" value="Reset password" fluidWidth />
                    <Submit onClick={goToLogin} type="button" value="Go to login" isSecondary fluidWidth />
                </ButtonsWrapper>
            </div>
        </ScreenWrapper>
    );
});
